import React from 'react';
import ComponentWrapper from '../../../components/layout/ComponentWrapper';
import { StudyCopyBlock, StudyDesignArms, StudyDesignOverview } from '../index';
import SecondaryCallout from '../../SecondaryCallout';
import styled from 'styled-components';
import { NAVIGATION_BREAKPOINT } from '../../../constants/layout';
import TextBlock from '../../TextBlock';
import { Heading , NotationBlock} from '../../../util/typography';

const bp= NAVIGATION_BREAKPOINT

const StyledComponentWrapper = styled(ComponentWrapper)`

.box-multi-color-gray, .box-multi-color-green {
   text-align: center;
}

@media(min-width: ${bp}){

  div:nth-child(2) {
        div:nth-child(2){
        > div {
           table {
             tr:first-child dd 
             { padding-top: 23px;
               padding-bottom: 37px;
             }
             tr:nth-child(5) td dl {
             dd:nth-child(2) {
                padding-top: 50px;
                padding-bottom: 58px;
                }
             dd:nth-child(3) {
                padding-bottom: 64px; }
             }
             tr:nth-child(7) dd {
             padding-top: 10px;
             padding-bottom: 26px;
             }
            }
        }
    }
}

}`;

const KeyTitle = styled(Heading.H4)``;


const HNSCC_Squamous = () => (
    <StyledComponentWrapper>
        <StudyDesignOverview
            title="Study Overview"
            description="KEYNOTE-689: A randomized, multicenter, open-label, active-controlled trial in 714 patients with resectable, locally advanced (stage III–IVA)<sup>d</sup> head and neck squamous cell carcinoma (LA HNSCC)"
            data={[
                [
                    {
                        title: 'Selected Inclusion Criteria:<sup>2</sup>',
                        description: `
                    <ul>
                        <li>Age ≥18 years</li>
                        <li>Histologically confirmed new diagnosis of non-metastatic resectable LA HNSCC that was either:
                            <ul>
                                <li>Stage III p16-positive oropharyngeal disease (T4, N0-2, M0)<sup>d</sup></li>
                                <li>Stage III or IVA p16-negative oropharyngeal disease<sup>d</sup></li>
                                <li>Stage III or IVA laryngeal/hypopharyngeal/oral cavity disease<sup>d</sup></li>
                            </ul>
                        </li>
                        <li>Eligible for primary surgery</li>
                        <li>ECOG PS 0 or 1</li>
                    </ul>
                    <h5>Stratification Factors:</h5>
                    <ul>
                        <li>Tumor PD-L1 status (TPS ≥50% vs <50%)</li>
                        <li>Primary tumor site (oropharynx/oral cavity vs larynx vs hypopharynx)</li>
                        <li>Tumor stage (stage III vs IVA)</li>
                     </ul> 
                `
                        
                ,
                        type: 'box-gradient',
                        colspan: 2
                    }
                ],
                [
                    { type: 'arrow-gray' ,
                        colspan: 2
                    } 
                ],
                [
                    {
                        title: 'Randomized 1:1 (N=714)',
                        colspan: 2
                    }
                ],
                [
                    {
                        type: 'arrow-green',
                    },
                    {
                        type: 'arrow-gray',
                    }
                ],
            ]} />

        <StudyDesignArms
            title="Study Arms"
            arms={[
                {
                    title: "",
                    data: [
                        [
                            {
                                title: `
                                <div class="h7"><b>KEYTRUDA Arm (n=363):<br>Neoadjuvant Treatment</b></div>
                            `,
                                description: [
                                    {
                                        text: `KEYTRUDA 200 mg IV Q3W<br>for 2 cycles<br>`,
                                        textCenter: true
                                    },
                                ],
                                type: 'box-multi-color-green'
                            }
                        ],
                        [
                            {
                                type: 'arrow-green',
                            }
                        ],
                        [
                            {
                                title: 'Surgery',
                            }
                        ],
                        [
                            {
                                type: 'arrow-green',
                            }
                        ],
                        [
                            {
                                title: `
                                <div class="h7"><b>KEYTRUDA Arm:<br>Adjuvant Treatment</b><br/><b>(started within 6 weeks following surgery)</b></div>
                            `,
                                description: [
                                    {
                                        text: `KEYTRUDA 200 mg IV Q3W (3 cycles)`,
                                        textCenter: true
                                    },
                                    {
                                        text: `Radiotherapy ± cisplatin`,
                                        conditional: 'and',
                                        textCenter: true
                                    }, 
                                ],
                                type: 'box-multi-color-green'
                            }
                        ],
                        [
                            {
                                type: 'arrow-green',
                            }
                        ],
                        // [
                        //     {
                        //         title: 'OR',
                        //     }
                        // ],
                        // [
                        //     {
                        //         type: 'arrow-green',
                        //     }
                        // ],
                        [
                            {
                                title: `
                                <div class="h7"><b>KEYTRUDA Arm:<br>Adjuvant Treatment</b></div>
                                `,
                                description: [
                                    {
                                        text: `<div>KEYTRUDA 200 mg IV Q3W (for up to 12 cycles)</div>`,
                                        textCenter: true
                                    }
                                ],
                                type: 'box-multi-color-green'
                            }
                        ],
                    ]
                },
                {
                    title: "",
                    data: [
                        [
                            {
                                title: `
                                <div class="h7"><b>SOC Arm (n=351):<br>No Neoadjuvant Treatment</b></div>
                            `,
                                description: [
                                    {
                                        text: `No Neoadjuvant Treatment<sup>2</sup>`,
                                        textCenter: true
                                    },
                                ],
                                type: 'box-multi-color-gray'
                            }
                        ],
                        [
                            {
                                type: 'arrow-gray',
                            }
                        ],
                        [
                            {
                                title: 'Surgery',
                            }
                        ],
                        [
                            {
                                type: 'arrow-gray',
                            }
                        ],
                        [
                            {
                                title: `
                                <div class="h7"><b>SOC Arm:<br>Adjuvant Treatment</b><br/><b>(started within 6 weeks following surgery)</b></div>
                            `,
                                type: 'box-multi-color-gray',
                                description: [
                                    {
                                        text: `<div>Radiotherapy ± cisplatin</div>
                                          `,
                                        textCenter: true,
                                        
                                    },


                                ],
                            }
                        ],
                        // [
                        //     {
                        //         type: 'arrow-gray',
                        //     }
                        // ],
                        // [
                        //     {
                        //         title: 'OR',
                        //     }
                        // ],
                        // [
                        //     {
                        //         type: 'arrow-gray',
                        //     }
                        // ],
                        // [
                        //     {
                        //         title: `
                        //         <div class="h7"><b>Arm B:<br>Adjuvant Therapy</b></div>
                        //         `,
                        //         type: 'box-multi-color-gray',
                        //         description: [
                        //             {
                        //                 text: `<div>RT only</div>
                        //                   `,
                        //                 textCenter: true
                        //             },
                        //         ],
                        //         type: 'box-multi-color-gray'
                        //     }
                        // ],
                    ]
                },
            ]}
            additionalInformation={`
        <ul>
            <li>In both treatment arms, patients received cisplatin 100 mg/m<sup>2</sup> IV Q3W x 3 cycles with adjuvant RT if high-risk pathological features (ie, positive margins <1 mm or extranodal extension) were present at surgery. Radiotherapy dosing was also directed by post-surgical pathological features: low-risk pathological features = 60 Gy (2 Gy/day in 30 fractions); high-risk pathological features = 66 Gy (2 Gy/day in 33 fractions); gross residual disease = 70 Gy (2 Gy/day in 35 fractions)</li>
            <li>Treatment with KEYTRUDA continued until disease progression by RECIST v1.1 per BICR during the neoadjuvant phase that precluded surgery, local or metastatic recurrence during the adjuvant phase, completion of treatment, or unacceptable toxicity</li>
            <li>Assessment of tumor status was performed prior to surgery at week 6 in the neoadjuvant phase. Following the start of the adjuvant phase, assessment of tumor status was performed 12 weeks after the end of RT with or without cisplatin treatment and then every 3 months until the end of year 3; then every 6 months thereafter up to the end of year 5</li>
            <li>The trial was not designed to isolate the effect of KEYTRUDA in each phase (neoadjuvant or adjuvant) of treatment</li>
            </ul>
    `}
    definitions="BICR = blinded indepedent central review; ECOG PS = Eastern Cooperative Oncology Group performance status; Gy = gray unit; Q3W = every 3 weeks; RECIST v1.1 = Response Evaluation Criteria in Solid Tumors v1.1; TPS = tumor proportion score."
    footnotes={[
        {
            label: 'd. ',
            text: 'Staged per the American Joint Committee on Cancer (AJCC) 8th edition.',
        }
    ]}


        />
        
        {/* <SecondaryCallout
            title="In Arm A, 89% of patients had surgery, compared to 88% in Arm B. In Arm A, 29% of patients received cisplatin plus radiation and 46% received radiation alone. In Arm B, 40% of patients received cisplatin plus radiation, and 39% received radiation alone."
        /> */}

        <StudyCopyBlock
            title='End Points'
            description={`
            <ul>
                <li><b>Major efficacy outcome measure:</b> 
                    <ul>
                        <li><strong>Event-free survival (EFS)</strong> as assessed by BICR and defined as the time from randomization to the first occurrence of any of the following events: progression of disease that precluded definitive surgery, local or distant disease progression or recurrence, or death due to any cause</li>
                    </ul>
                </li>
                <li><b>Additional efficacy outcome measures:</b>
                    <ul>
                       <li><strong>Major pathological response (mPR)</strong> as assessed by BIPR</li>
                       <li><strong>Overall survival</strong></li>
                    </ul>
                </li>
            </ul>
        `}
        />

        <StudyCopyBlock
            title="Patient Baseline Characteristics (CPS ≥1) (n=682)"
            description={`
            <ul>
                <li>Median age: 60 years (range: 22–87)</li>
                <li>Age ≥65 years or older: 33%</li>
                <li>Male: 79%</li>
                <li>Race
                    <ul>
                        <li>White: 78%</li>
                        <li>Hispanic or Latino: 14%</li>
                        <li>Asian: 13%</li>
                        <li>Black or African American: 2.5%</li>                       
                    </ul>
                </li>
                <li>ECOG PS
                    <ul>
                        <li>0: 57%</li>
                        <li>1: 43%</li>
                    </ul>
                </li>
                <li>Smoking status
                    <ul>
                        <li>Former/current: 79%</li>
                    </ul>
                </li>
                <li>Stage
                    <ul>
                        <li>Stage III: 26%</li>
                        <li>Stage IVA: 74%</li>
                    </ul>
                </li>
                <li>HPV-positive tumors: 4%</li>
                <li>PD-L1 expression
                    <ul>
                        <li>CPS ≥10: 68%</li>
                    </ul>
                </li>
            </ul>
            
        `}
            // footnotes={[{
            //     label: 'f. ',
            //     text: 'mPR as assessed by BIPR.'
            // }]}
            //definitions='BIPR = blinded independent pathology review; HPV = human papillomavirus; ECOG PS = Eastern Cooperative Oncology Group performance status; IV = intravenous; PD-L1 = programmed death ligand 1; Q3W = every 3 weeks; RECIST v1.1 = Response Evaluation Criteria In Solid Tumors v1.1; TPS = tumor proportion score; CPS = combined positive score.'
        />
        <TextBlock>
               <KeyTitle>Treatments Received (CPS ≥1)</KeyTitle>
               <p>88% of patients underwent definitive surgery in both the KEYTRUDA and the SOC (adjuvant RT ± cisplatin) arms (CPS ≥1)</p>
                    <ul>
                        <li>In an exploratory subgroup analysis of 555 patients with PD-L1–positive (CPS ≥1) oral cavity, oropharyngeal, and laryngeal tumors who underwent surgery:
                            <ul>
                                <li>91% of patients in the KEYTRUDA arm underwent R0 resections</li>
                                <li>85% of patients in the SOC arm underwent R0 resections</li>
                            </ul>
                        </li>
                        <li>
                            In an exploratory subgroup analysis of 51 patients with PD-L1–positive (CPS ≥1) hypopharyngeal tumors who were randomized, the EFS HR was 2.28 (95% CI, 0.79–6.56). Among these patients:
                            <ul>
                                <li>23 patients in the KEYTRUDA arm underwent surgery, of whom 17 patients (74%) underwent R0 resections</li>
                                <li>In the SOC arm, 23 patients underwent surgery, of whom 20 (87%) underwent R0 resections</li>
                            </ul>
                        </li>
                    </ul>
                    <p>76% of patients in the KEYTRUDA arm and 78% of patients in the SOC arm started the radiation phase of treatment after surgery</p>
                    <ul>
                        <li> In the KEYTRUDA arm:
                            <ul>
                                <li>35% received KEYTRUDA + cisplatin + concurrent RT</li>
                                <li>57% received KEYTRUDA + concurrent RT</li>
                                <li>3% received cisplatin alone with concurrent RT</li>
                                <li>5% received RT alone</li>
                                <li>0.4% (1 patient) received KEYTRUDA alone without concurrent RT</li>
                            </ul>
                        </li>
                        <li>In the SOC arm:
                            <ul>
                                <li>52% received cisplatin + concurrent RT</li>
                                <li>48% received RT alone</li>
                            </ul>
                        </li>
                    </ul>
        </TextBlock>

        <NotationBlock
            title=""
            definitions="BIPR = blinded independent pathology review; HPV = human papillomavirus."
            footnotes={[]}
            data={[]}
         />



    </StyledComponentWrapper>
);

export default HNSCC_Squamous;